import React from 'react';

import { nanoid } from '@reduxjs/toolkit';

import { MediaFile } from 'src/types/media';

import styles from './banner.module.scss';
import { MediaLibrary } from 'src/types/mediaLibrary';
import { MediaLibraryChooser } from 'src/components/mediaLibrary';
import { useBannerAdoption } from 'src/query/settings/adoption/accountManagement';

interface BannerEditorProps {
  collection: any;
  onChange: (field: string, value: any) => void;
}

const BannerEditor: React.FC<BannerEditorProps> = ({ collection, onChange }) => {

  const {trackBannerContentSelected} = useBannerAdoption(); 

  const handleFileChange = (background: MediaFile) => {
    const banner = {
      position: collection.banner?.position || 'top',
      autoHeightEnabled: collection.banner?.autoHeightEnabled ?? true,
      sharedByEnabled: collection.banner?.sharedByEnabled ?? true,
      ...collection.banner,
      background: {
        ...background,     
        mediaType: background.type
      },
      crop: null,
    };
  
    onChange('banner', banner);
  
    trackBannerContentSelected({
      bannerType: banner?.background?.type || "",
      sourceCta: "Settings",
    });
  }

  const handleBannerSelection = (media: MediaLibrary) => {
    if (!media) {
      return;
    }

    const imageUrl = media.imageUrl;
    console.log('imageUrl', imageUrl);
    if(!imageUrl) {
      return;
    }

    fetch(imageUrl)
    .then((response) => {
      return response.blob();
    })
    .then(blob => {
      const url = URL.createObjectURL(blob);

      const backgroundMedia = {
        id: nanoid(6),
        entityType: 'media-preview',
        type: media.mediaType,
        full: url,
        thumbnail: url,
        width: media.width,
        height: media.height,
        contentType: blob.type,
      } as MediaFile
    
      handleFileChange(backgroundMedia);
    }).catch(error => {
      console.error(error);
    });
  }

  return (
    <div className={styles.bannerChooser}>
      <MediaLibraryChooser entityType="collection" onChange={handleBannerSelection} columns={5}/>
    </div>
  );
}

export { BannerEditor };